/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */

import {Col, Nav, Collapse, Button} from "react-bootstrap";
import {useState, useEffect, useRef} from "react";
import { useReactToPrint } from "react-to-print";
import TreePcg from "../components/TreePcg";
import TreePGProjects from "../components/TreePGProjects";
import RightInformation from "../components/rightInformation";
import {Resizable} from "re-resizable";
import "../styles/project.css";
import {useSelector, useDispatch} from "react-redux";
import PrintIcon from '@material-ui/icons/Print';
import {
	selectMeanV2,
	selectProyectV2,
	treePc,
	treePCGProjects,
	resetOnlyProject,
	resetOnlyClassification,
	ClassificationResourceV2,
	GraficoPCG,
	ProjectDetailsPc,
	selectPc,
	PCGProjectsGraphicWithHead,
	ListarPorPeriodoGrafico,
	ListarPorPeriodoDetallesGrafico,
	ListarPorPeriodoPcDetalles,
	ListarPorPeriodoMains,
	TableMeans,
	ListarPorPeriodo,
} from "../actions/proyects.actions";
import {coinsFn} from '../actions/pcg.action';

import TreeMeansV2 from "../components/TreeMeansV2";
import LoadingModal from "../components/LoadingModal";

const PcGeneral = (props) => {
	const dispatch = useDispatch();
	const proyects = useSelector((state) => state.proyects);
	const pcg = useSelector((state) => state.pcg);
	const auth = useSelector((state) => state.auth);
	const [width, setWidth] = useState(400);
	const [height, setHeight] = useState(200);
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = useState(true);
	const [secondTabData, setSecondTabData] = useState([]);
	
	const codPCGUrl = props.location.pathname.split("/")[2];
	const codProUrl = props.location.pathname.split("/")[4];
	const codMeansUrl = props.location.pathname.split("/")[6];


	const [myMoney, setMyMoney] = useState('S/.');
	const [typeMoney, setTypeMoney] = useState('06');
	// const [urlPcg, setUrlPcg] = useState('');
	const [pesNav, setPesNav] = useState('nav1');
	const [itemsSelecteds, setItemsSelecteds] = useState({});
	const [title, setTitle] = useState('');

	const componentRef = useRef();
	const itemsSelectedsRef = useRef();

	useEffect(() => {
		itemsSelectedsRef.current = itemsSelecteds;
	}, [itemsSelecteds]);

	useEffect(() => {
		if( !pcg.coins || pcg.coins.length === 0 ) dispatch(coinsFn());
		// TODO: restart redux before call store classification
		dispatch(resetOnlyProject());
		dispatch(resetOnlyClassification());
		if( proyects.treePartyControl.length === 0 ) dispatch(treePc('', typeMoney));
		// eslint-disable-next-line
	}, [typeMoney]);

	useEffect(() => {
		if ( codPCGUrl &&  pesNav === 'nav2' && proyects.TreeProyects.length === 0) {
			dispatch(treePCGProjects( typeMoney, codPCGUrl ));
		}
		if ( codProUrl && pesNav === 'nav3' && proyects.treeDataTab3['Level1'] === undefined) {
			// setUrlPcg(codPCGUrl);
			dispatch(ClassificationResourceV2(codProUrl, typeMoney, codPCGUrl));
		}
	}, [pesNav])

	useEffect(() => {
		dispatch(resetOnlyProject());
		// if ( codPCGUrl ) {
		// 	setUrlPcg(codPCGUrl);
		// 	dispatch(treePCGProjects( typeMoney, codPCGUrl ));
		// 	if ( !pesNav && codPCGUrl && !codMeansUrl ) setPesNav('nav2');
		// }
		// eslint-disable-next-line
	}, [codPCGUrl]);

	useEffect(() => {
		dispatch(resetOnlyClassification());
		// if ( codProUrl ) {
		// 	dispatch(ClassificationResource(codProUrl, typeMoney, codPCGUrl)); // TODO: pType
		// 	if ( !pesNav && codMeansUrl ) setPesNav('nav3');
		// }
		// eslint-disable-next-line
	}, [codProUrl]);

	useEffect(() => {
		setSecondTabData( proyects.TreeProyects );
	}, [proyects.TreeProyects]);

	// useEffect(() => {
	// 	setThreeTabData( proyects.classicationData );
	// }, [proyects.classicationData]);

	const onSelectItem = (tabNumber, treeItem, headSelected = '') => {
		let items = itemsSelectedsRef.current;
		if(tabNumber !== -1) items[tabNumber] = treeItem;
		let title = 'PCG';
		if(headSelected) title += ` (${headSelected})`
		for (let i = 1; i <= 3; i++) {
			if (tabNumber !== -1) {
				if ( i <= tabNumber) {
					items[i] = itemsSelectedsRef.current[i];
				} else {
					items[i] = undefined;
				}
			}
			if( items[i] !== undefined ) title += ` - ${items[i].Descripcion}`
		}
		setItemsSelecteds(items);
		setTitle(title);
	}

	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	});

	const hadlerMeansGraphic = (option = '1') => {
		dispatch(
			ListarPorPeriodoMains(codProUrl, codPCGUrl, typeMoney, codMeansUrl, option, auth.scaleSelected, auth.dateSelected)
		)
	}

	const hadlerProjectsGraphicWithHead = (head, option = '1') => {
		dispatch(PCGProjectsGraphicWithHead(
			codProUrl,
			codPCGUrl,
			typeMoney,
			head,
			option,
		))
	}

	const handlerGeneralPCWithHead = (head, option = '1') => {
		if (option === '1') {
			dispatch(ListarPorPeriodoPcDetalles(
				'YYYYY002',
				codPCGUrl,
				head,
				typeMoney, 
				auth.dateSelected,
				auth.scaleSelected, 
			))
		} else {
			dispatch(ListarPorPeriodoDetallesGrafico(
				'YYYYY002',
				head,
				codPCGUrl,
				typeMoney, 
				auth.scaleSelected, 
				auth.dateSelected,
			));
		}
	}

	return (
		<>
		{loading && <LoadingModal show={true} />}
		<div className="d-flex flex-wrap justify-content-between overflow-hidden h-100">
			<Resizable
				className="tree-fixed p-0 d-flex h-100 justify-content-between"
				size={{width: width}}
				maxHeight="95vh"
				maxWidth={open ? "30vw" : 0}
				minHeight="95vh"
				minWidth={open ? "20vw" : 0}
				onResizeStop={(e, direction, ref, d) => {
					setWidth(width + d.width);
					setHeight(height + d.height);
				}}
			>
				<Collapse in={open}>
					<div className="p-2 mt-1 w-100">
						<div className="dropdown mr-1">
							<button
								type="button"
								className="btn btn-secondary dropdown-toggle"
								id="dropdownMenuOffset"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
								data-offset="10,20"
							>
								Moneda ({myMoney})
							</button>
							<div
								className="dropdown-menu"
								aria-labelledby="dropdownMenuOffset"
							>
								{
									pcg.coins.map(coin => (
										<a
											key={coin.Tipo}
											className="dropdown-item"
											onClick={() =>{ 
												setTypeMoney(coin.Tipo)
												setMyMoney(coin.Simbolo)}
											}
										>
											{coin.DesMoneda}
										</a>
									))
								}
							</div>
						</div>

						<div className="mb-2">
							
							<Nav
								variant="tabs"
								defaultActiveKey="/home"
								className="eyelashes mt-3"
							>
								<Nav.Item>
									<Nav.Link
										to="#"
										active={pesNav === "nav1"}
										onClick={() => {
											setPesNav('nav1');
										}}
									>
										PC General
									</Nav.Link>
								</Nav.Item>

								<Nav.Item>
									<Nav.Link
										to="#"
										eventKey="link-1"
										active={pesNav === "nav2"}
										onClick={() => {
											// dispatch(treePcg(urlPcg, typeMoney));
											setPesNav('nav2');
										}}
									>
									Proyectos
									</Nav.Link>
								</Nav.Item>

								<Nav.Item>
									<Nav.Link
										to="#"
										eventKey="link-3"
										active={pesNav === "nav3"}
										onClick={() => {
											// dispatch(treePcg(urlProject, typeMoney));
											setPesNav('nav3');
										}}
									>
										Recursos
									</Nav.Link>
								</Nav.Item>

								<Nav.Item>
									<div style={{paddingLeft: 5}}>
										<Button onClick={handlePrint}><PrintIcon/></Button>
									</div>
								</Nav.Item>
							</Nav>
						
						</div>

						<div
							className="mt-2 p-2 overflow-auto"
							style={{height: "80vh"}}
						>
							
							{ pesNav === "nav1" && <TreePcg
								pesNav={pesNav}
								nodeSelected={codPCGUrl}
								data={ proyects.treePartyControl }
								typeMoney={typeMoney}
								urlPrefix={'/pc-general/'}
								onSelectItem={(item) => onSelectItem(1, item)}
							/>}
							{ pesNav === "nav2" && codPCGUrl && <TreePGProjects
								pesNav={pesNav}
								nodeSelected={codProUrl}
								data={ secondTabData }
								typeMoney={typeMoney}
								resetDate={false}
								urlPrefix={`/pc-general/${codPCGUrl}/proyecto/`}
								onSelectItem={(item) => onSelectItem(2, item)}
							/>}
							{pesNav === "nav3" && codProUrl && <TreeMeansV2 
								idMeans={codMeansUrl}
								data={proyects.treeDataTab3}
								urlPrefix={`/pc-general/${codPCGUrl}/proyecto/${codProUrl}/recurso/`}
								onSelectItem={(item) => onSelectItem(3, item)}
								setChanges={(codInsumo, nivel, search, cleanData=false) => {
									if (cleanData) {			
										dispatch(resetOnlyClassification());
									}
									dispatch(ClassificationResourceV2(codProUrl, typeMoney, codPCGUrl, codInsumo, nivel, search))
								}}
							/>}
						</div>
					</div>
				</Collapse>
				<div
					className="bara-cerrar potencia d-flex align-items-center"
					style={{
						width: 12,
						height: "100%",
						background: "#dee2e6",
					}}
				>
					<div
						style={{cursor: "pointer"}}
						className="h-25 w-100 bg-primary d-flex align-items-center"
						onClick={() => {
							setOpen(!open);
						}}
						aria-controls="example-collapse-text"
						aria-expanded={open}
					>
						{open ? (
							<ion-icon name="caret-back-outline"></ion-icon>
						) : (
							<ion-icon name="caret-forward-outline"></ion-icon>
						)}
					</div>
				</div>
			</Resizable>

			<Col className="bigs-data px-4 w-100" style={{width: '100%', maxWidth: '100%'}}>
				<div className="page-break" ref={componentRef} >
					<h4 className="project-title">
						{proyects.titleProject && proyects.titleProject.split(' / ')[1] + ' - ' + proyects.titleProject.split(' / ')[2]}
					</h4>
					{pesNav === "nav1" && codPCGUrl && <RightInformation
						codProyect={'YYYYY002'}
						codClassification={codPCGUrl}
						codType={typeMoney}
						cardInformationRedux={() => dispatch(selectProyectV2(codPCGUrl, typeMoney, auth.dateSelected, auth.scaleSelected))}
						graphicBarRedux={() => dispatch(ListarPorPeriodoGrafico('YYYYY002', codPCGUrl, typeMoney, auth.scaleSelected, auth.dateSelected))}
						graphicBarWithHeadRedux={(head) => handlerGeneralPCWithHead(head, '2')}
						tableDetailsRedux={() => dispatch(ProjectDetailsPc('YYYYY002', codPCGUrl, typeMoney, auth.scaleSelected, auth.dateSelected))}
						graphicLinesRedux={() => 
							dispatch(ListarPorPeriodo(
								'YYYYY002', 
								codPCGUrl, 
								typeMoney,
								auth.dateSelected,
								auth.scaleSelected,
							))}
						graphicLinesWithHeadRedux={(head) => handlerGeneralPCWithHead(head, '1')}
						changeDate={true}
						cardTitle={title}
						onSelectTableTitle={(title) => onSelectItem(-1, undefined, title)}
						handleLoading={setLoading}
					/>}
					{pesNav === "nav2" && codProUrl && <RightInformation
						codProyect={codProUrl}
						codClassification={codPCGUrl}
						codType={typeMoney}
						cardInformationRedux={() => dispatch(selectPc(codProUrl, codPCGUrl, typeMoney))}
						graphicLinesRedux={() => dispatch(GraficoPCG(codProUrl, typeMoney, codPCGUrl, 1))}
						graphicBarRedux={() => dispatch(GraficoPCG(codProUrl, typeMoney, codPCGUrl, 0))}
						tableDetailsRedux={() => dispatch(ProjectDetailsPc(codProUrl, codPCGUrl, typeMoney, auth.scaleSelected, auth.dateSelected))}
						graphicLinesWithHeadRedux={(head) => hadlerProjectsGraphicWithHead(head, '1')}
						graphicBarWithHeadRedux={(head) => hadlerProjectsGraphicWithHead(head, '0')}
						cardTitle={title}
						onSelectTableTitle={(title) => onSelectItem(-1, undefined, title)}
						handleLoading={setLoading}
					/>}
					{pesNav === "nav3" && codMeansUrl && <RightInformation
						codProyect={codProUrl}
						codClassification={codPCGUrl}
						codType={typeMoney}
						codMeans={codMeansUrl}
						cardInformationRedux={() => dispatch(selectMeanV2(codProUrl, codPCGUrl, typeMoney, codMeansUrl, auth.dateSelected, auth.scaleSelected))}
						graphicLinesRedux={() => hadlerMeansGraphic()}
						graphicBarRedux={() => hadlerMeansGraphic('0')}
						tableMeansRedux={() => dispatch(TableMeans(codProUrl, codPCGUrl, typeMoney, codMeansUrl, auth.scaleSelected, auth.dateSelected))}
						cardTitle={title}
						handleLoading={setLoading}
					/>}
					{/* {pesNav === "nav3" && codMeansUrl && <IdMeans
						codClassification={codPCGUrl}
						codProject={codProUrl}
						codType={typeMoney}
						codMeans={codMeansUrl}

					/>} */}
				</div>
				
			</Col>
		</div>
		</>
	);
};

export default PcGeneral;
